<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1> <i class="fa-thin fa-user"></i> Cadastrar novo Usuário</h1>
                <hr />
                 <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <form v-if="!exibeLoading" @submit.prevent="handleUsuario">
                        <div class="form-group mb-3">
                            <input type="text" v-model="email" placeholder="E-mail do usuário" class="form-control" required/>
                        </div>
                        <div class="form-group mb-3">
                            <input type="text" v-model="nome" placeholder="Nome do usuário" class="form-control" required/>
                        </div>
                        <div class="form-group">
                            <input type="text" v-model="password" placeholder="Digite uma senha" class="form-control" required/>
                        </div>
                        <button style="margin-left:0px;" class="btn btn-primary mt-4">Cadastrar</button>
                    </form>
                    <Alert style="margin-top:20px;" v-if="exibeAlert" :tipo="tipoS" :msg="msgS" />
            </div>
            </div>
        </div>
    </div>
    </template>

<script setup>
import { ref } from 'vue';
import Menu from '@/components/Menu.vue';
import Usuarios from '@/servicos/Usuarios';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';

const email = ref('')
const nome = ref('')
const password = ref('')
const exibeAlert = ref(false)
const tipoS = ref('')
const msgS = ref('')
const exibeLoading = ref(false)

const handleUsuario = async () => {
    exibeLoading.value = true
    const response = await Usuarios.CadastrarUsuario(email.value, nome.value, password.value)

    if(response.response){
        exibeAlert.value = true
        tipoS.value = 'danger',
        msgS.value = response.response.data.message
        exibeLoading.value = false
    }

    if(response.id){
        exibeAlert.value = true
        tipoS.value = 'success',
        msgS.value = "Usuário adicionado com sucesso"
        email.value = ''
        nome.value = ''
        password.value = ''
        exibeLoading.value = false
    }

}
</script>


    <style>
    
    h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
    /* .table>:not(caption)>*>* { background-color:#1B3639;  } */
    th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
    th { background-color: #1B3639 !important;}
    .cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
    
    </style>